export default 'skill-bites'
